module.exports = __webpack_public_path__ + "static/media/bg-1.f8446605.png";